import * as React from 'react';
import { CaretLeft, CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { recordAnalyticsForAboutUsPageView } from '@/redux/modules/analytics';
import { useAppDispatch } from '@/redux/hooks';
import { useLocation, useParams } from 'react-router-dom';
import { waitToDispatch } from '@/utils/waitToDispatch/waitToDispatch';
import Header from '@/components/Lightbox/Header/Header';
import Lightbox from 'react-spring-lightbox';
import useConsoleCarouselData from './hooks/useConsoleCarouselData';
import useIsServerSideRendered from '@/hooks/useIsServerSideRendered';

export type RouteParams = {
    catalogId: string;
    imageNum: string;
    itemId: string;
};

const ImageCarouselPopoutPage = () => {
    const dispatch = useAppDispatch();
    const {
        catalogId: catalogIdString,
        imageNum: imageNumWhenPoppedOut,
        itemId: itemIdString,
    } = useParams<RouteParams>();

    const location = useLocation();

    const catalogId = Number(catalogIdString);
    const itemId = Number(itemIdString);
    const initialIndex = Number(imageNumWhenPoppedOut) - 1;

    const { canNext, canPrev, currentImageIndex, currentItem, gotoNext, gotoPrevious, mappedPhotos } =
        useConsoleCarouselData({ catalogId, initialIndex, itemId });

    React.useEffect(() => {
        waitToDispatch(recordAnalyticsForAboutUsPageView, dispatch, location);
    }, [dispatch, location]);

    const isSsr = useIsServerSideRendered();

    if (isSsr) {
        return null;
    }

    return (
        <Lightbox
            currentIndex={currentImageIndex}
            images={mappedPhotos}
            isOpen
            onNext={gotoNext}
            onPrev={gotoPrevious}
            renderHeader={() => (
                <Header
                    currentImageIndex={currentImageIndex}
                    galleryLength={mappedPhotos.length}
                    galleryTitle={currentItem?.title}
                    itemId={itemId}
                    onClose={() => window.close()}
                />
            )}
            renderNextButton={() => (
                <IconButton
                    className="absolute right-sm z-10 xsMax:hidden"
                    disabled={!canNext}
                    icon={CaretRight}
                    iconStyle="bold"
                    onClick={gotoNext}
                    variant="outlined"
                />
            )}
            renderPrevButton={() => (
                <IconButton
                    className="absolute left-sm z-10 xsMax:hidden"
                    disabled={!canPrev}
                    icon={CaretLeft}
                    iconStyle="bold"
                    onClick={gotoPrevious}
                    variant="outlined"
                />
            )}
            singleClickToZoom
        />
    );
};

export default ImageCarouselPopoutPage;
